import React from 'react';

const NewsCard = ({ result, tilePalette, resultImageId }) => {
    // Check if `result` and `result.listMetadata`
    // exist before accessing their properties
    const listMetadata = result?.listMetadata;

    return (
        <a
            className="news-media-card resource-tile__container"
            href={listMetadata?.pageUrl?.[0]}
        >
            <div className={`resource-tile theme--${tilePalette}`}>
                <div className="resource-tile__front">
                    <div className="resource-tile__front-top">
                        <div className="resource-tile__content">
                            <div className="resource-tile__image-container">
                                <div className="resource-tile__image-position position--center">
                                    <img
                                        className="resource-tile__image"
                                        src={
                                            listMetadata?.assetImage?.[0] ??
                                            `./?a=${resultImageId}`
                                        }
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="resource-tile__front-bottom">
                        <div className="resource-tile__content">
                            <div>
                                {!!listMetadata?.assetTitle?.[0] && (
                                    <h2 className="resource-tile__title front--title">
                                        {listMetadata?.assetTitle?.[0]}
                                    </h2>
                                )}
                            </div>
                            <div className="resource-tile__link front--link">
                                {!!listMetadata?.assetPublished?.[0] && (
                                    <span className="resource-tile__link-text">
                                        {listMetadata?.assetPublished?.[0]}
                                    </span>
                                )}
                                <svg className="svg-icon resource-tile__arrow-icon resource-tile__arrow-long-icon">
                                    <use href="#rse-arrow-right" />
                                </svg>
                                <svg className="svg-icon resource-tile__arrow-icon resource-tile__arrow-bold-icon">
                                    <use href="#rse-arrow-right-bold" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="resource-tile__back">
                    <div className="resource-tile__back-top">
                        {!!listMetadata?.assetTitle?.[0] && (
                            <h2 className="resource-tile__title back--title">
                                {listMetadata?.assetTitle?.[0]}
                            </h2>
                        )}
                        {!!listMetadata?.assetDescription?.[0] && (
                            <p className="resource-tile__text back--text">
                                {listMetadata?.assetDescription?.[0]}
                            </p>
                        )}
                    </div>
                    <div className="resource-tile__back-bottom">
                        <div className="resource-tile__content">
                            <div>
                                {!!listMetadata?.assetPartnerLogo?.[0] && (
                                    <div className="resource-tile__logo-div">
                                        <img
                                            className="svg-icon resource-tile__logo-icon"
                                            alt=""
                                            src={
                                                listMetadata
                                                    ?.assetPartnerLogo?.[0]
                                            }
                                        />
                                    </div>
                                )}
                                <div>
                                    {!!listMetadata?.assetAuthor?.[0] && (
                                        <p className="author-name">
                                            {listMetadata?.assetAuthor?.[0]}
                                        </p>
                                    )}
                                    {!!listMetadata
                                        ?.assetContentReadMinutes?.[0] && (
                                        <p className="read-duration">
                                            {
                                                listMetadata
                                                    ?.assetContentReadMinutes?.[0]
                                            }{' '}
                                            min read
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="resource-tile__link">
                                <span className="resource-tile__link-text">
                                    Read more
                                </span>
                                <svg className="svg-icon resource-tile__arrow-icon">
                                    <use href="#rse-arrow-right" />
                                </svg>
                                <svg className="svg-icon resource-tile__arrow-icon resource-tile__arrow-bold-icon">
                                    <use href="#rse-arrow-right-bold" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
};

export default NewsCard;
